import React, { createContext, useContext } from 'react';
interface ThemeContextType {
  theme: 'light';
}
const ThemeContext = createContext<ThemeContextType | undefined>(undefined);
export const ThemeProvider: React.FC<{
  children: React.ReactNode;
}> = ({
  children
}) => {
  const theme = 'light';
  return <ThemeContext.Provider value={{
    theme
  }} data-id="element-97">
      {children}
    </ThemeContext.Provider>;
};
export const useTheme = (): ThemeContextType => {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};